import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { GridConfig } from './data-grid-config.interface';

/** Host-provided grid configuration stream. */
export interface GridConfigSource {
  readonly config$: Observable<GridConfig>;
}

export const GRID_CONFIG_SOURCE: InjectionToken<GridConfigSource> = new InjectionToken<GridConfigSource>(
  'GRID_CONFIG_SOURCE'
);
